import shop1 from "../data/images/shop1.jpg";
import shop2 from "../data/images/shop2.jpg";
import shop3 from "../data/images/shop3.jpg";
import shop4 from "../data/images/shop4.jpg";
import shop5 from "../data/images/shop5.jpg";
import shop6 from "../data/images/shop6.jpg";
import shop7 from "../data/images/shop7.jpg";
import shop8 from "../data/images/shop8.jpg";
import shop9 from "../data/images/shop9.jpg";

export const shopData = [
  {
    category: "jewelry",
    shops: [
      {
        name: "WeAreArrow Jewellery",
        LAT: 51.5289945,
        LON: -0.0719384,
        phone: "+442075890588", //fake data
        email: "arrow@wearearrow.com",
        country: "UK",
        city: "London",
        address: "118 Columbia Road ",
        address2: "",
        address3: "E2 7RG",
        icon: shop1,
      },
      {
        name: "Jessica de Lotz Jewellery",
        LAT: 51.5539548,
        LON: -0.1428859,
        phone: "+447958689591",
        email: "jessica@jessicadelotz.co.uk",
        country: "UK",
        city: "London",
        address: "49 Fortess Road ",
        address2: "Kentish Town",
        address3: "NW5",
        icon: shop2,
      },
      {
        name: "Tatty Devine",
        LAT: 51.5030739,
        LON: -0.1422907,
        phone: "+442078362685",
        email: "care@tattydevine.com",
        country: "UK",
        city: "London",
        address: "Unit 9, Hopewell Business Centre 105 ",
        address2: "Hopewell Drive Kent",
        address3: "ME5 7DX",
        icon: shop3,
      },
    ],
  },
  {
    category: "clothes",
    shops: [
      {
        name: "ATIKA",
        LAT: 51.52109869181407,
        LON: -0.07090288465645676,
        phone: "+442073770730",
        email: "hello@atikalondon.co.uk",
        country: "UK",
        city: "London",
        address: "55-59 Hanbury St ",
        address2: "",
        address3: "E1 5JP",
        icon: shop4,
      },
      {
        name: "AIDA Schroditch",
        LAT: 51.5265515,
        LON: -0.0804012,
        phone: "+442077392811",
        email: "aida@aidashoreditch.co.uk",
        country: "UK",
        city: "London",
        address: "133 Shoreditch H. Street ",
        address2: "Shoreditch",
        address3: "E1 6JE",
        icon: shop5,
      },
      {
        name: "Alex Eagle",
        LAT: 51.5122446,
        LON: -0.1374801,
        phone: "+442075890588",
        email: "info@alexeagle.co.uk",
        country: "UK",
        city: "London",
        address: "6-10 Lexington Street ",
        address2: "",
        address3: "W1F 0LB",
        icon: shop6,
      },
    ],
  },
  {
    category: "electronic",
    shops: [
      {
        name: "MJ ALL TEC LTD",
        LAT: 51.5289945,
        LON: -0.0719384,
        phone: "+4420 7580 2135",
        email: "sales@mjalltec.com",
        country: "UK",
        city: "London",
        address: "246 Tottenham Court Road ",
        address2: "",
        address3: "W1T 7QU",
        icon: shop7,
      },
      {
        name: "iFix Centre",
        LAT: 51.4608057,
        LON: 0.1773866,
        phone: "+442072281888",
        email: "info@ifixcentre.co.uk",
        country: "UK",
        city: "London",
        address: "86 Battersea Rise ",
        address2: "",
        address3: "SW11 1EJ",
        icon: shop8,
      },
      {
        name: "Power Buddy",
        LAT: 51.5079507,
        LON: 0.0650038,
        phone: "+448005677162",
        email: "info@powerbuddy.co.uk", //fake data
        country: "UK",
        city: "London",
        address: "8, 2 Pinchin St ",
        address2: "Whitechapel",
        address3: "E1 1SA",
        icon: shop9,
      },
    ],
  },
];
